import { getCookie } from '@/lib/utils/getCookies';

import { isBrowser } from './config';
import { getHeaderValue } from './headers';

export const normalizeLocale = (
  raw: string | null | undefined,
): string | undefined => {
  if (!raw) return undefined;
  return raw === 'vlca' ? 'es' : raw;
};

export const getEffectiveLocale = async (
  optsLocale?: string,
  reqHeaders?: HeadersInit,
): Promise<string | undefined> => {
  if (optsLocale) return normalizeLocale(optsLocale);

  // caller-provided headers can include accept-language
  const fromHeaders = normalizeLocale(
    getHeaderValue(reqHeaders, 'accept-language'),
  );
  if (fromHeaders) return fromHeaders;

  if (isBrowser()) {
    return normalizeLocale(
      getCookie('NEXT_LOCALE') || (getCookie('language') as string) || 'en',
    );
  }

  // server-side cookies/headers
  try {
    const { cookies, headers } = await import('next/headers');
    const c = await cookies();
    const h = await headers();

    const cookieLocale = normalizeLocale(
      c.get('language')?.value || c.get('NEXT_LOCALE')?.value,
    );
    if (cookieLocale) return cookieLocale;

    const headerLocale = normalizeLocale(h.get('accept-language'));
    return headerLocale ?? 'en';
  } catch {
    return 'en';
  }
};
